module.exports = __webpack_public_path__ + "img/shopping-cart.b476da7c.svg";